// Shared color/series definitions for the Quality KPI charts — centralized
// here so a future palette tweak doesn't require hunting across every tab
// file (flagged in AI review on PR #284, tracked as QA-7156).
//
// The same 4-shade "tier ramp" (critical → minor) represents severity across
// every different domain's own field names (PI's P1–P4, Support's P0–P3,
// EPD's severity, and the DSI's own tier labels) — TIER_COLORS is the single
// source of truth for those shades; each *_SERIES export below just maps a
// domain's field names onto it.

export const TIER_COLORS = {
  critical: '#b91c1c',
  major: '#e07b7b',
  moderate: '#f0a8a8',
  minor: '#fbdcdc',
};

export const ORIGIN_COLORS = {
  cs: '#e08a4c',
  hj: '#7fb069',
  heap: '#5aa9e6',
};

export const DSI_LINE_COLOR = '#2563eb';

// Production Incident priority tiers (P1 Critical .. P4 Low) — used by both
// the Production Incident tab and the Defect Severity Index tab's PI chart.
export const PI_PRIORITY_SERIES = [
  { key: 'p1Critical', name: 'P1 - Critical', color: TIER_COLORS.critical },
  { key: 'p2Major', name: 'P2 - Major', color: TIER_COLORS.major },
  { key: 'p3Medium', name: 'P3 - Medium', color: TIER_COLORS.moderate },
  { key: 'p4Low', name: 'P4 - Low', color: TIER_COLORS.minor },
];

// Support priority tiers (P0 Blocker .. P3 Low).
export const SUP_PRIORITY_SERIES = [
  { key: 'p0Blocker', name: 'P0 - Blocker', color: TIER_COLORS.critical },
  { key: 'p1High', name: 'P1 - High', color: TIER_COLORS.major },
  { key: 'p2Medium', name: 'P2 - Medium', color: TIER_COLORS.moderate },
  { key: 'p3Low', name: 'P3 - Low', color: TIER_COLORS.minor },
];

// EPD severity tiers — no "moderate" tier here (EPD's severity field has no
// equivalent value), so only 3 of the 4 tier colors are used.
export const EPD_SEVERITY_SERIES = [
  { key: 'critical', name: 'Critical', color: TIER_COLORS.critical },
  { key: 'major', name: 'Major', color: TIER_COLORS.major },
  { key: 'minor', name: 'Minor', color: TIER_COLORS.minor },
];

// Defect Severity Index's own tier labels — used by both the DSI tab and the
// Quality Overview tab's embedded DSI charts.
export const DSI_TIER_SERIES = [
  { key: 'critical', name: 'Critical Impact', color: TIER_COLORS.critical },
  { key: 'major', name: 'Major Impact', color: TIER_COLORS.major },
  { key: 'moderate', name: 'Moderate Impact', color: TIER_COLORS.moderate },
  { key: 'minor', name: 'Minor Impact', color: TIER_COLORS.minor },
];

export const DSI_LINE = { key: 'dsi', name: 'DSI', color: DSI_LINE_COLOR };

// Origin breakdown (CS/HJ/Heap-Incident labels) — used by the Production
// Incident tab and the Quality Overview tab's Service Disruption section.
export const ORIGIN_SERIES = [
  { key: 'cs', name: 'CS-Incident', color: ORIGIN_COLORS.cs },
  { key: 'hj', name: 'HJ-Incident', color: ORIGIN_COLORS.hj },
  { key: 'heap', name: 'Heap-Incident', color: ORIGIN_COLORS.heap },
];
